import {
	FRAME_BLOCK,
	frameHtml,
} from "@productlane/lib/src/tiptap/extensions/mintlify/frame-html"
import {
	readProps,
	stringProp,
	unwrapParagraph,
} from "@productlane/lib/src/tiptap/extensions/mintlify/layout-props"

import type { MdxBlockReader } from "./registry"

export const frameReaders: MdxBlockReader[] = [
	{
		name: "frame",
		pattern: new RegExp(FRAME_BLOCK.source, "g"),
		render: (match, parseBody) => {
			const props = readProps(match[1] ?? "")
			const inline = (key: string) => {
				const value = stringProp(props, key)?.trim()
				return value ? unwrapParagraph(parseBody(value)) : ""
			}
			const body = match[2] ?? ""
			return frameHtml({
				hintHtml: inline("hint"),
				captionHtml: inline("caption"),
				mediaHtml: body.trim() ? parseBody(body) : "",
			})
		},
	},
]
